import { Col, Form, Row } from "antd";
import { useAppSelector } from "core/presentation/store/hooks";
import { useNavigate } from "react-router-dom";
import { OrderMatchingCost } from "./OrderMatchingCost";
import UsernamePoints from "./UsernamePoints";
import OngoingTrips from "./OngoingTrips";
import VehicleLocations from "./VehicleLocations";

const VehicleOwnerMainDashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <UsernamePoints />
      {/* <Row gutter={[16, 16]}>
        <Col md={12}>
          {" "}
          </Col>
          <Col md={12}>
          {" "}
          <OrderMatchingCost />
          </Col>
          </Row> */}
      <VehicleLocations />
      <OngoingTrips />
    </>
  );
};

export default VehicleOwnerMainDashboard;
